export const APPROVED_BY_LENDER_STATUSES: string[] = ['APPROVED_BY_LENDER'];
